import React from 'react';

import { DataBar } from '@qality/common-components/src/atoms/DataBar';
import { ExecutionStatusSummary } from '@qality/common-model';
import { CssUtils } from '@qality/common-utils';

type Props = {
  statusInSummary: ExecutionStatusSummary[number];
};

export function ExecutionStatusSummarySingleBarChart({
  statusInSummary,
}: Props): JSX.Element {
  return (
    <DataBar.Container>
      <DataBar.Value
        value={statusInSummary.percent}
        color={CssUtils.cssDsTokenVar(
          statusInSummary.status.color.backgroundToken
        )}
      />
    </DataBar.Container>
  );
}
